import React from 'react';
import classNames from 'classnames';
import listStyles from '../list.module.scss';
import unorderedStyles from './unordered.module.scss';

type Props = {
  children: React.ReactNode;
};

export const UL: React.FC<Props> = ({ children }) => {
  return <ul className={classNames(listStyles.root, unorderedStyles.root)}>{children}</ul>;
};
